//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";

function servicePLUSAuditAPI() {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/signature-audit/service-plus?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/signature-audit/search-service?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function Export(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/signature-audit/service-export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getAPI,
    searchAPI,
    Export
  };

}

export default servicePLUSAuditAPI;
